import styled from 'styled-components';
import ShipperDetailUsers from './component';

export default styled(ShipperDetailUsers)`
  .shipper-detail-users {
    &__header {
      padding: 1rem 2rem;
      color: var(--grey700);
    }

    &__row {
      width: 100%;
      padding: 1rem 2rem;
      height: 4rem;
      border-bottom: 1px solid var(--grey300);

      .light {
        color: var(--grey500);
      }

      &:hover {
        background-color: var(--primary100);

        .shipper-detail-users {
          &__actions {
            display: flex;
          }
        }
      }
      > div {
        margin-right: 1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    &__row--open {
      background-color: var(--primary100);

      .shipper-detail-users {
        &__actions {
          display: flex;
        }
      }
    }

    &__row--closed {
      background-color: var(--white);
    }

    &__actions {
      display: none;
    }
  }

  .success {
    font-weight: 500;
    color: var(--success700);
    line-height: 4rem;
  }
`;
